import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  category: "",
  comparedProducts: [],
  expiresIn: 60,
  isEnable: false,
  compareSectionData: [],
}

export const compareSlice = createSlice({
  name: "compare",
  initialState,
  reducers: {
    clearProduct(state, action) {
      state.comparedProducts.forEach(obj => {})
      const products = state.comparedProducts.filter(
        product => product.compareSku !== action.payload
      )
      const query = products.map(item => item.compareSku).join(",")
      const path = `${
        products.length > 0 ? "?compare=" : ""
      }${query.toString()}`
      if (!query) {
        window.history.replaceState(null, "", window.location.pathname)
      } else {
        window.history.replaceState(
          window.location.pathname,
          document.title,
          path
        )
      }

      state.category = products.length === 0 ? "" : state.category
      state.comparedProducts = products
    },

    setCompareExpiry(state, action) {
      state.expiresIn = action.payload
    },

    clearAllCompareProducts(state, action) {
      state.category = ""
      state.comparedProducts = []
    },

    addCompareProducts(state, action) {
      try {
        const { expiresIn } = state
        const {
          productData = {},
          backorder = false,
          compareSku = "",
          slug = "",
        } = action.payload
        const product = productData
        if (product && Object.keys(product).length > 0) {
          product.compareSku =
            compareSku || productData.sku_s || productData.sku
          product.expiry = Date.now() + expiresIn * 24 * 3600 * 1000
          product.backorder = backorder
          product.slug = slug
          const productsTemp = state.comparedProducts
          const alreadyExist = productsTemp.some(obj => {
            return (
              obj.compareSku === productData.sku_s ||
              obj.compareSku === productData.sku
            )
          })
          if (!alreadyExist) {
            const prodMain = productsTemp.filter(obj => {
              return (
                obj.compareSku !== productData.sku_s ||
                obj.compareSku !== productData.sku
              )
            })
            prodMain.push(product)
            state.comparedProducts = prodMain
            state.category = productData.Product_Category
              ? productData.Product_Category
              : productData.ProductLocalCategory_s ?? productData.category ?? ""
          }
        }
        state.isEnable = false
      } catch (error) {
        state.isEnable = false
      }
    },

    updateCompareStatus(state, action) {
      state.isEnable = action.payload
    },
  },
})

export const {
  setCompareExpiry,
  clearAllCompareProducts,
  addCompareProducts,
  clearProduct,
  updateCompareStatus,
} = compareSlice.actions
export const compareState = state => state.compare
